export var IHighlightType;
(function (IHighlightType) {
    IHighlightType["BEST_VALUE"] = "best_value";
    IHighlightType["MOST_POPULAR"] = "most_popular";
})(IHighlightType || (IHighlightType = {}));
